import React from 'react';
import UiButton from '@components/ui/button/UiButton';
import makeTypedTranslation from '@hooks/typedTranslations/makeTypedTranslation';
import styles from './AlreadyHaveAnAccount.module.scss';

const AlreadyHaveAnAccount = ({ onClick }: { onClick: Function }) => {
  const { useTypedTranslation } = makeTypedTranslation('signup');
  const { t: translate } = useTypedTranslation('signup');

  return (
    <section className={styles.footer}>
      <p className="large-body-text title-dark no-margin">{translate('already_have_registered_company')}</p>
      <UiButton type="link" data-testid="login-button" onClick={() => onClick()}>
        {translate('login')}
      </UiButton>
    </section>
  );
};

export default AlreadyHaveAnAccount;
